
import axios from '../../axios/interceptor.js';

// Get a Stripe Checkout URL
export const getFinanceRecommendations = async () => {
    const response = await axios.get(`/customer/finance-recommendations/get`);
    return response.data;
};
